<ngx-simplebar class="doughnut-chart-container">
  <div
    id="top-row"
    [ngClass]="{
      hide: loading() || timeOut() || noData() || noEnergyLoss(),
    }"
  >
    <span class="energyToolWidgetTitle">{{ "energy_tool.doughnut_chart.title" | translate }}</span>
    <select
      class="custom_select"
      (change)="onChangeTimeSelect(selectRef)"
      id="time-window-button"
      [value]="selectedTimeWindow()"
      #selectRef
    >
      <option value="today">
        {{ "energy_tool.doughnut_chart.today" | translate }}
      </option>
      <option value="yesterday">
        {{ "energy_tool.doughnut_chart.yesterday" | translate }}
      </option>
      <option value="this_week">
        {{ "energy_tool.doughnut_chart.this_week" | translate }}
      </option>
      <option selected value="this_month">
        {{ "energy_tool.doughnut_chart.this_month" | translate }}
      </option>
    </select>
  </div>

  <div id="canvas-container" [ngClass]="{ noData: noData() || noEnergyLoss() }">
    @if (chartId()) {
      <canvas
        class="chart"
        [ngClass]="{
          hide: loading() || timeOut() || noData() || noEnergyLoss(),
        }"
        [id]="chartId()"
      ></canvas>
    }
  </div>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (noData()) {
      {{ "common.no_data" | translate }}
    } @else if (noEnergyLoss()) {
      {{ "energy_tool.no_data_in_timeframe" | translate }}
    } @else {
      <ngx-simplebar [options]="{ autoHide: false }" class="list-container">
        <div class="list-item list-title grey-text">
          @if (sourceType() === assetTypes.BUILDING) {
            <span>{{ "energy_tool.doughnut_chart.gate_system" | translate }}</span>
          }
          @if (sourceType() === assetTypes.LOCATION) {
            <span>{{ "energy_tool.doughnut_chart.building" | translate }}</span>
          }

          <span>{{ "energy_tool.doughnut_chart.share_of_energy_loss" | translate }}</span>
        </div>
        @for (entityItem of energyLossShare; track entityItem) {
          <div class="list-item">
            <span>{{ entityItem.label }}</span>
            <span>{{ entityItem.relativeValue }} %</span>
          </div>
        }
      </ngx-simplebar>
    }
  }
</ngx-simplebar>
